<template>
    <div class="kgr-inputGroup">
        <div class="kgr-inputGroup__label">
            {{ $t('Vertragsart:') }}
        </div>

        <kgr-checkbox-group
            label-prefix="StatusPicker.checkbox.type"
            inline
            :value="types"
            :options="contractTypeOptions"
            @post-input="emit"
        >
            <kgr-checkbox
                v-model="noMembershipSelected"
                :label="statusNoMembership.label"
                inline
                :info="noMembershipSelected ? statusNoMembership.info : null"
                @change="emit"
            />
        </kgr-checkbox-group>
        <br />
        <div class="kgr-inputGroup__label">
            {{ $t('Aktueller Vertragsstatus des Mitglieds:') }}
            <kgr-icon-info
                v-if="noMembershipOnlySelected"
                accent
                :title="$t('StatusPicker.noMembershipOnlySelected.info')"
                class="icon-info-position"
                @click.stop
            />
            <kgr-icon-info
                v-else-if="noMembershipSelected"
                accent
                :title="$t('StatusPicker.noMembershipSelected.info')"
                class="icon-info-position"
                @click.stop
            />
        </div>
        <kgr-checkbox-group
            label-prefix="StatusPicker.checkbox.status"
            inline
            :value="selectedStatuses"
            :options="contractStatusOptions"
            :inactive="noMembershipOnlySelected"
            field-for-label="label"
            field-for-info="info"
            @post-input="emit"
        />
        <br />
    </div>
</template>

<script>
import Checkbox from '../checkbox/Checkbox.vue';
import CheckboxGroup from '../checkbox/CheckboxGroup';
import IconInfo from '../../icon/IconInfo.vue';

export default {
    components: {
        'kgr-icon-info': IconInfo,
        'kgr-checkbox': Checkbox,
        'kgr-checkbox-group': CheckboxGroup,
    },
    props: {
        statuses: {
            type: Array,
            required: true,
        },
        types: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            noMembershipSelected: false,
            statusNoMembership: {
                id: 3,
                label: this.$t('Keine Mitgliedschaft'),
                info: this.$t('StatusPicker.noMembership.info'),
            },
            contractStatusOptions: [
                { id: 1, label: this.$t('Laufend') },
                { id: 0, label: this.$t('Beendet') },
                { id: 2, label: this.$t('Geplant') },
            ],
            contractTypeOptions: ['regular', 'passive', 'guest'],
        };
    },
    computed: {
        selectedStatuses() {
            return this.contractStatusOptions.filter((s) => this.statuses.indexOf(s.id) !== -1);
        },
        noMembershipOnlySelected() {
            return this.types.length === 0 && this.noMembershipSelected;
        },
    },
    created() {
        this.noMembershipSelected = this.statuses.find((s) => s === this.statusNoMembership.id) != null;
    },
    methods: {
        emit() {
            const statuses = this.selectedStatuses;
            if (this.noMembershipSelected) {
                statuses.push(this.statusNoMembership);
            }
            const result = {
                statuses: statuses.map((s) => s.id),
                types: this.types,
            };
            this.$emit('input', result);
            this.$nextTick(() => {
                this.$emit('post-input', result);
            });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .icon-info-position {
    vertical-align: text-bottom;
}
.kgr-inputGroup__label {
    line-height: 2em;
}
.statuses-disabled {
    opacity: 0.3;
}
</style>
